module.exports = {
  "calendar": "Kalend\u0101rs",
  "day": "diena",
  "dayPeriod": "priek\u0161pusdien\u0101/p\u0113cpusdien\u0101",
  "endDate": "Beigu datums",
  "era": "\u0113ra",
  "hour": "stundas",
  "minute": "min\u016Btes",
  "month": "m\u0113nesis",
  "second": "sekundes",
  "selectedDateDescription": function selectedDateDescription(args) {
    return "Atlas\u012Btais datums: ".concat(args.date);
  },
  "selectedRangeDescription": function selectedRangeDescription(args) {
    return "Atlas\u012Btais diapazons: no ".concat(args.startDate, " l\u012Bdz ").concat(args.endDate);
  },
  "selectedTimeDescription": function selectedTimeDescription(args) {
    return "Atlas\u012Btais laiks: ".concat(args.time);
  },
  "startDate": "S\u0101kuma datums",
  "timeZoneName": "laika josla",
  "weekday": "ned\u0113\u013Cas diena",
  "year": "gads"
};